(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brand-model-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('mouseover', function(event) {
  const button = event.target.closest('.model-guide-toggle');
  if (button) button.setAttribute('aria-pressed', 'true');
});
document.addEventListener('mouseout', function(event) {
  const button = event.target.closest('.model-guide-toggle');
  if (button && !button.contains(event.relatedTarget)) button.setAttribute('aria-pressed', 'false');
});
document.addEventListener('click', function(event) {
  const button = event.target.closest('.model-guide-toggle');
  if (button && event.pointerType !== 'mouse') button.setAttribute('aria-pressed', button.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
});
  } catch(e) { console.error(e); }
})();

})();
